// In-memory access-token store (issue #6) — mirrors demo-frontend's
// common/services/tokenStore. The access token is never persisted; the
// session is restored via the orchestrator's httpOnly refresh cookie
// (silently exchanged for a fresh token on app load).
let accessToken: string | null = null;

export const tokenStore = {
  get: (): string | null => accessToken,
  set: (token: string | null): void => {
    accessToken = token;
  },
  clear: (): void => {
    accessToken = null;
  },
};

// One-time cleanup of tokens persisted by older versions of the app.
export const purgeLegacyTokenStorage = (): void => {
  if (typeof window === 'undefined') return;
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};
